import { useMutation } from '@apollo/client/react'
import { useSearchParams } from 'react-router-dom'
import { gql } from '@apollo/client'
import Spinner from '../Spinner/Spinner'
import { RESET_PASSWORD_TOKEN_MUTATION } from '../../graphql.js'
import ResetPassword from './ResetPassword'
import MessageCard from '../MessageCard/MessageCard'

const RESET_PASSWORD_TOKEN = gql(RESET_PASSWORD_TOKEN_MUTATION)

export default function ResetPasswordContainer() {
  console.log('ResetPasswordContainer rendered')

  const [searchParams] = useSearchParams()
  const [resetPasswordToken, { loading, error, data }] = useMutation(RESET_PASSWORD_TOKEN)
  const token = searchParams.get('token')

  console.log(token)

  if (token && !loading && !error && !data) {
    resetPasswordToken({ variables: { token: token } })
  }

  if (loading) {
    return <Spinner />
  } else if (error) {
    return error.message
  } else if (data) {
    if (data.resetPasswordToken) {
      return (<ResetPassword userId={data.resetPasswordToken} />)
    } else {
      return (
        <MessageCard
          title='Password Reset Request Expired'
          message='Please click the "Forgot Password" link on the login screen to generate a new request.'
          buttonText="Go To Login"
          clickUrl="/login"
        />
      )
    }
  }
  return ''
}
